import Axios from 'axios';

class BoletoAndPixResendService {
  resend(billId, extraRecipient, includeSpecialDiscounts) {
    return Axios.post('/admin/bill-payments/resend-boleto-and-pix', {
      bill_id: billId,
      extra_recipient: extraRecipient,
      include_special_discounts: includeSpecialDiscounts,
    });
  }
}

export default new BoletoAndPixResendService();
